import axios from 'axios'

// let baseUrl = 'http://localhost:7904/api'
// let baseUrl = 'https://virbac-cms.warnny.com/api'
let baseUrl = 'https://virbac-cms-stg.warnny.com/api'

// 创建axios实例
const service = axios.create({
    baseURL: baseUrl,
    timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)
export default service
